import { OrientableComponent } from "./OrientableComponent.types";

export type Dimensions = {
  width: number;
  height: number;
  depth: number;
};

export class Sculpture extends OrientableComponent {
  // private static num = 0
  uuid: string | null

  z: number
  dimensions: Dimensions

  constructor(mapRefUUID?: string) {
    super(mapRefUUID)

    this.z = 0
    this.dimensions = { height: 50, width: 50, depth: 50 }

    this.uuid = mapRefUUID || null
  }
}